import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/liquidaciones-configuraciones-percepciones';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET Liquidaciones Configuraciones Indemnizaciones
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLiquidacionesConfiguracionesIndemnizaciones = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLiquidacionConfiguracionIndemnizacion = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Liquidacion Configuracion Indemnizacion
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLiquidacionConfiguracionIndemnizacion = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLiquidacionConfiguracionIndemnizacion = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLiquidacionConfiguracionIndemnizacion = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarLiquidacionConfiguracionIndemnizacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/autorizar`);
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * CANCELAR Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const cancelarLiquidacionConfiguracionIndemnizacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/cancelar`);
    onSuccess(response, 'Cancelado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * REACTIVAR Liquidacion Configuracion Indemnizacion
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const reactivarLiquidacionConfiguracionIndemnizacion = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}/reactivar`);
    onSuccess(response, 'Reactivado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
